module.exports = __webpack_public_path__ + "img/logo.979c1c8b.png";